import PropTypes from "prop-types";

import { Switch as SwitchComponent } from "antd";
import classnames from "classnames";
import { useTranslation } from "react-i18next";
import { NAME_SPACES } from "shared/locales/constants";
import Label from "../Label";

const Switch = ({
  label,
  placeholder,
  icon,
  innerRef,
  required,
  optional,
  checkedChildren,
  unCheckedChildren,
  ...rest
}) => {
  const { t } = useTranslation(NAME_SPACES.COMPONENTS);
  const SWITCH = t("SWITCH", { returnObjects: true });
  return (
    <div className={classnames("acoris__switch")}>
      <Label
        label={label}
        icon={icon}
        required={required}
        optional={optional}
      />
      <div className="acoris__switch--field">
        <SwitchComponent
          className={classnames("button__switch", {
            "disable--input": rest.disabled,
          })}
          ref={innerRef}
          checkedChildren={checkedChildren || SWITCH.YES}
          unCheckedChildren={unCheckedChildren || SWITCH.NO}
          {...rest}
        />
      </div>
    </div>
  );
};

Switch.propTypes = {
  label: PropTypes.string,
};

Switch.defaultProps = {
  label: "",
};

export default Switch;
